<template>
    <div>
        <b-sidebar id="sidebar-backdrop-lead" :backdrop-variant="'dark'" :title="$t('addLeadRecord.title')" backdrop shadow
            :visible="allowAddLead" :right="true" no-header-close no-close-on-backdrop no-close-on-esc>
            <div class="d-block mt-3">
                <b-row class="px-4">
                    <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('addLeadRecord.basic') }}</h3>
                    <b-col sm="12" class="mt-3">
                        <div class="text-left">
                            <label for="modal-datepicker" class="state">{{ $t('addLeadRecord.dateLabel') }}</label>
                            <date-picker v-model="recordPayload.date" :formatter="momentFormat"
                                :range-separator="' - '" @clear="recordPayload.date = ''" :placeholder="$t('addLeadRecord.selectDate')"
                                class="date-picker-custom f-12" :teleport="'body'"></date-picker>
                            <p v-if="errors && errors.date" class="field-error">
                                {{ errors.date[0] }}
                            </p>
                        </div>
                    </b-col>
                    <b-col sm="12" class="text-left mt-3">
                        <label class="state">{{ $t('addLeadRecord.recruiterLabel') }}</label>
                        <v-select class="bg_white w-100 f-12" v-model="recordPayload.owner" :options="nameOptions"
                            item-value="id" item-text="label" :reduce="(option) => option.id" @search="searchUsers">
                            <span slot="no-options">
                                {{ $t('addLeadRecord.searchRecruiter') }}
                            </span>
                        </v-select>
                        <p v-if="errors && errors.owner" class="field-error">
                            {{ errors.owner[0] }}
                        </p>
                    </b-col>
                    <b-col sm="12" class="mt-3">
                        <b-form-group :label="$t('addLeadRecord.firstNameLabel')" class="text-left mb-0">
                            <b-form-input v-model="recordPayload.first_name" :placeholder="$t('addLeadRecord.firstNamePlaceholder')"
                                class="unit f-12" required></b-form-input>
                            <p v-if="errors && errors.first_name" class="field-error">
                                {{ errors.first_name[0] }}
                            </p>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" class="mt-3">
                        <b-form-group :label="$t('addLeadRecord.lastNameLabel')" class="text-left mb-0">
                            <b-form-input v-model="recordPayload.last_name" :placeholder="$t('addLeadRecord.lastNamePlaceholder')"
                                class="unit f-12" required></b-form-input>
                            <p v-if="errors && errors.last_name" class="field-error">
                                {{ errors.last_name[0] }}
                            </p>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" class="mt-3">
                        <b-form-group :label="$t('addLeadRecord.phoneLabel')" class="text-left position-relative mb-0">
                            <b-input-group size="lg" class="w-100 f-12" prepend="+1">
                                <b-form-input v-mask="phoneMask" class="f-12" v-model="recordPayload.phone"
                                    :placeholder="$t('addLeadRecord.phonePlaceholder')"></b-form-input>
                            </b-input-group>
                            <p v-if="errors && errors.phone" class="field-error mt-2">
                                {{ errors.phone[0] }}
                            </p>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" class="mt-3">
                        <b-form-group :label="$t('addLeadRecord.emailLabel')" class="text-left mb-0">
                            <b-form-input v-model="recordPayload.email" :placeholder="$t('addLeadRecord.emailPlaceholder')" class="unit f-12"
                                required></b-form-input>
                            <p v-if="errors && errors.email" class="field-error">
                                {{ errors.email[0] }}
                            </p>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" class="mt-3">
                        <div class="text-left">
                            <label class="state">{{ $t('addLeadRecord.statusLabel') }}</label>
                            <b-form-select class="f-12" :options="statusOptions" v-model="recordPayload.status">
                            </b-form-select>
                            <p v-if="errors && errors.status" class="field-error">
                                {{ errors.status[0] }}
                            </p>
                        </div>
                    </b-col>
                    <b-col sm="12" class="text-left mt-3 sidebar-b-margin">
                        <label class="state">{{ $t('addLeadRecord.jobLabel') }}</label>
                        <v-select class="bg_white w-100 f-12" v-model="recordPayload.job" :options="jobOptions"
                            item-value="id" item-text="label" :reduce="(option) => option.id" @search="searchJobs">
                            <span slot="no-options">
                                {{ $t('addLeadRecord.searchJob') }}
                            </span>
                        </v-select>
                        <p v-if="errors && errors.job" class="field-error">
                            {{ errors.job[0] }}
                        </p>
                    </b-col>
                </b-row>
            </div>
            <div class="sidebar-footer position-fixed">
                <div class="text-right modal-footer border-0 p-0">
                    <b-button class="mx-0 mr-3 h-40px w-100px" @click="resetFilterFields()"
                        variant="secondary">{{ $t('addLeadRecord.cancel') }}</b-button>
                    <b-button class="mx-0 h-40px w-100px" @click="createLead()" variant="primary">{{ $t('addLeadRecord.save') }}</b-button>
                </div>
            </div>
        </b-sidebar>
    </div>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import * as moment from "moment-timezone";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { mapActions, mapGetters } from "vuex";
import { checkPhoneFormat, checkEmail } from '../../services/helper';
export default {
    name: "AddLeadRecord",
    props: ['allowAddLead'],
    components: {
        DatePicker,
        vSelect
    },
    data() {
        return {
            nameOptions: [],
            jobOptions: [],
            checkPhoneFormat,
            checkEmail,
            recordPayload: {
                date: new Date(),
                owner: '',
                first_name: '',
                last_name: '',
                phone: '',
                email: '',
                status: 'New Lead',
                job: ''
            },
            errors: {},
            momentFormat: {
                stringify: (date) => {
                    return date ? moment(date).format('ll') : ''
                },
                parse: (value) => {
          if (!value) return null
          const formats = [
            'll', 'LL',
            'MMM D, YYYY', 'MMMM D, YYYY',
            'M/D/YYYY', 'MM/DD/YYYY',
            'M-D-YYYY', 'MM-DD-YYYY',
            'YYYY-MM-DD', 'YYYY/MM/DD',
            'D MMM YYYY', 'D MMMM YYYY',
            'D/M/YYYY', 'DD/MM/YYYY',
          ]
          const m = moment(value, formats, true)
          if (m.isValid()) return m.toDate()
          const lenient = moment(value)
          return lenient.isValid() ? lenient.toDate() : null
        }
            },
        };
    },
    computed: {
        ...mapGetters(['allTeamMembers', 'user']),
        statusOptions() {
            return [
                { text: '-', value: '' },
                { text: this.$t('addLeadRecord.statusNewLead'), value: 'New Lead' },
                { text: this.$t('addLeadRecord.statusContacted'), value: 'Contacted' },
                { text: this.$t('addLeadRecord.statusFollowUp'), value: 'Follow Up' },
                { text: this.$t('addLeadRecord.statusOnboarding'), value: 'Onboarding' },
                { text: this.$t('addLeadRecord.statusLeadClosed'), value: 'Lead Closed' },
                { text: this.$t('addLeadRecord.statusApplied'), value: 'Applied' },
                { text: this.$t('addLeadRecord.statusUnderReview'), value: 'Under Review' },
                { text: this.$t('addLeadRecord.statusScreening'), value: 'Screening' },
                { text: this.$t('addLeadRecord.statusRejected'), value: 'Rejected' },
            ];
        },
        phoneMask() {
            return this.recordPayload.phone?.length > 0
                ? [
                    /\d/, /\d/, /\d/, " ",
                    /\d/, /\d/, /\d/, " ",
                    /\d/, /\d/, /\d/, /\d/
                ]
                : false; // Allows empty input
        }
    },
    watch: {
        allowAddLead(val) {
            if (val) this.setOwner();
        }
    },
    methods: {
        ...mapActions(['setLoader', 'getAllTeamMembers', 'getRecruitingData', 'addLeadData', 'setNotification']),
        setOwner() {
            this.recordPayload.owner = `${this.user.team_member.id}`;
            this.nameOptions = [{
                id: `${this.user.team_member.id}`,
                label: this.user.first_name + ' ' + this.user.last_name,
            }]
        },
        resetFilterFields(close = true) {
            this.recordPayload = {
                date: new Date(),
                first_name: '',
                owner: '',
                last_name: '',
                phone: '',
                email: '',
                status: 'New Lead',
                job: ''
            };
            this.errors = {};
            this.nameOptions = []
            this.jobOptions = []
            if (close) this.$emit('close');
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (!value) {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
        async searchUsers(searchText) {
            let options = []
            let url = `page=1&page_size=20&name=${searchText}`;
            await this.getAllTeamMembers(url);
            this.allTeamMembers.map((member) => {
                options.push({
                    id: `${member.id}`,
                    label: member.user.first_name + ' ' + member.user.last_name,
                });
            });
            this.nameOptions = options
            this.nameOptions = [...new Map(this.nameOptions.map(item => [item['id'], item])).values()]
        },
        async searchJobs(searchText) {
            let options = []
            let url = `page=1&page_size=20&name=${searchText}`;
            const data = await this.getRecruitingData({ type: "job", url });
            data.data.map((job) => {
                options.push({
                    id: `${job.id}`,
                    label: job.name,
                });
            });
            this.jobOptions = options
            this.jobOptions = [...new Map(this.jobOptions.map(item => [item['id'], item])).values()]
        },
        async createLead() {
            try {
                const nullKeys = this.checkNullValues({
                    date: this.recordPayload.date,
                    first_name: this.recordPayload.first_name,
                    last_name: this.recordPayload.last_name,
                    status: this.recordPayload.status,
                    job: this.recordPayload.job
                });
                if (this.recordPayload.phone) {
                    if (!this.checkPhoneFormat(this.recordPayload.phone)) {
                        throw {
                            phone: [this.$t('addLeadRecord.wrongFormat')],
                        };
                    }
                }
                if (this.recordPayload.email) {
                    if (!this.checkEmail(this.recordPayload.email)) {
                        throw {
                            email: [this.$t('addLeadRecord.wrongFormat')],
                        };
                    }
                }
                if (nullKeys.length === 0) {
                    this.setLoader(true)
                    await this.addLeadData({ ...this.recordPayload, date: moment(this.recordPayload.date).format('YYYY-MM-DD') });
                    await this.setNotification({
                        msg: this.$t('addLeadRecord.leadAdded'),
                        type: "success",
                        color: "green",
                    });
                    this.setLoader(false)
                    this.$emit("refreshLeads")
                    this.resetFilterFields();

                } else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('addLeadRecord.fieldRequired')];
                    });
                    throw error;
                }
            }
            catch (error) {
                if (typeof error === "object") {
                    this.errors = error;
                    // eslint-disable-next-line no-ex-assign
                }
                this.setLoader(false)
            }

        }
    }
};
</script>
